import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import More from './More'
import { twMerge } from 'tailwind-merge'
import { SIDE_MENU_PADDING } from '../../../constants/style-constants'

type OptionProps = {
  children: ((checked: boolean) => React.ReactNode) | React.ReactNode
  label?: string
  more?: boolean
  moreChecked?: boolean
  onToggle?: (checked: boolean) => void
}

const Option = ({ children, label, more, moreChecked = false, onToggle }: OptionProps) => {
  const { t } = useTranslation()
  const [checked, setChecked] = useState(moreChecked)
  function toggleMore() {
    setChecked(!checked)
    onToggle?.(!checked)
  }

  return (
    <div
      className={twMerge(
        'border-text-secondary/30 flex flex-col gap-2 border-b',
        SIDE_MENU_PADDING,
      )}
    >
      {label || more ? (
        <div className="flex items-center justify-between">
          {label && <span>{t(label)}</span>}
          {more && <More checked={checked} toggle={toggleMore} />}
        </div>
      ) : null}
      {typeof children === 'function' ? children(checked) : children}
    </div>
  )
}
export default Option
